<template>
  <generic-search-result
    class="search-result item item--search-result search-result--product"
    :title="title ? title : item.name"
    :text="text ? text : item.introText"
    :badge-text="badgeText ? badgeText : 'core.search.types.product.label'"
    :badge-icon="badgeIcon ? badgeIcon : 'bag'"
    :badge-theme="badgeTheme ? badgeTheme : 'lead'"
    :translate-badge-text="translateBadgeText"
    :image-url="imageUrl ? imageUrl : item.introImage"
    :tags="tags ? tags : item.Tags"
    :category="category ? category : item.Category"
    :item="item"
    :item-route="itemRoute"
    :show-actions="true"
    @search-result-item:request-close="$emit('search-result-item:request-close')">
    <template #title>
      <slot name="title">
        <span>{{ item.name }}</span> |
        <span style="font-weight: 400">{{
          translateNumber(item.price, "currency", { to: item.currency })
        }}</span>
      </slot>
    </template>
  </generic-search-result>
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
import searchResultItemMixin from "@/client/extensions/mixins/search/searchResultItem.js";

export default {
  components: {
    genericSearchResult: asyncComponentFactory(
      "components/items/generic/SearchResult.vue",
      true
    ),
  },
  mixins: [searchResultItemMixin],
  emits: ["search-result-item:request-close"],

};
</script>

<style scoped lang="scss"></style>
